import { PreactView } from '../preact-view'
import { Taskboard } from '../taskboard/taskboard'

const TaskboardPageView = PreactView.extend({
  title: 'Taskboard',
  component: Taskboard
})

export default TaskboardPageView
